import React, { useState, useEffect } from 'react';
import { partnerService } from '../../services/partnerService';

const DEFAULT_PARTNERS = [
  { id: '1', name: 'Imexpharm', logo_url: 'https://ckjfwkgtjwiiolqqmnoc.supabase.co/storage/v1/object/public/site-assets/partner-logos/1779247992287.svg', website_url: 'https://imexpharm.com' },
  { id: '2', name: 'DHG', logo_url: 'https://ckjfwkgtjwiiolqqmnoc.supabase.co/storage/v1/object/public/site-assets/partner-logos/1779248107439.svg', website_url: 'https://dhgpharma.com.vn' },
  { id: '3', name: 'Traphaco', logo_url: 'https://ckjfwkgtjwiiolqqmnoc.supabase.co/storage/v1/object/public/site-assets/partner-logos/1779249532928.svg', website_url: 'https://traphaco.com.vn' },
  { id: '4', name: 'PH', logo_url: 'https://ckjfwkgtjwiiolqqmnoc.supabase.co/storage/v1/object/public/site-assets/partner-logos/1779250363447.svg' },
  { id: '5', name: 'Boston', logo_url: 'https://ckjfwkgtjwiiolqqmnoc.supabase.co/storage/v1/object/public/site-assets/partner-logos/1779250134839.svg' },
  { id: '6', name: 'OPC', logo_url: 'https://ckjfwkgtjwiiolqqmnoc.supabase.co/storage/v1/object/public/site-assets/partner-logos/1779249856965.svg' },
  { id: '7', name: 'Sanofi', logo_url: 'https://ckjfwkgtjwiiolqqmnoc.supabase.co/storage/v1/object/public/site-assets/partner-logos/1779250196861.svg' },
  { id: '8', name: 'vidipha', logo_url: 'https://ckjfwkgtjwiiolqqmnoc.supabase.co/storage/v1/object/public/site-assets/partner-logos/1779249615199.svg' },
  { id: '9', name: 'Nam Hà', logo_url: 'https://ckjfwkgtjwiiolqqmnoc.supabase.co/storage/v1/object/public/site-assets/partner-logos/1779250512180.svg' },
  { id: '10', name: 'BR Pharma', logo_url: 'https://ckjfwkgtjwiiolqqmnoc.supabase.co/storage/v1/object/public/site-assets/partner-logos/1779250818392.svg' },
  { id: '11', name: 'TVPharm', logo_url: 'https://ckjfwkgtjwiiolqqmnoc.supabase.co/storage/v1/object/public/site-assets/partner-logos/1779251145343.svg' },
  { id: '12', name: 'PV', logo_url: 'https://ckjfwkgtjwiiolqqmnoc.supabase.co/storage/v1/object/public/site-assets/partner-logos/1779251263283.svg' }
];

export default function PartnerGrid({ className = '' }) {
  const [partners, setPartners] = useState(DEFAULT_PARTNERS);

  useEffect(() => {
    partnerService
      .getPublicPartners()
      .then((res) => {
        if (res.data && res.data.length > 0) {
          setPartners(res.data);
        }
      })
      .catch(() => {
        // Fallback to DEFAULT_PARTNERS
      });
  }, []);

  return (
    <div className={`partner-grid ${className}`.trim()} id="partnerGrid">
      {partners.map((p) => {
        const imgEl = <img src={p.logo_url} alt={p.name} loading="lazy" />;
        return p.website_url ? (
          <a
            key={p.id}
            className="partner-card"
            href={p.website_url}
            target="_blank"
            rel="noopener noreferrer"
            title={p.name}
          >
            {imgEl}
          </a>
        ) : (
          <div key={p.id} className="partner-card" title={p.name}>
            {imgEl}
          </div>
        );
      })}
    </div>
  );
}
